import { PLUGINS_KEYS } from "../../../other/constants/PluginKeys.jsx";
import { getOriginalRecord } from "../../../other/utils/utils.jsx";
import { createScheduleFileDropPluginClass } from "./createScheduleFileDropPluginClass.js";

/** File drop onto schedule right-side task grid rows (TaskDrag stays file-gated). */
export default createScheduleFileDropPluginClass({
  pluginName: PLUGINS_KEYS.swivuGridTaskFileDrop,
  getRootElement: (plugin) => plugin.client?.element,
  findDropTarget: (target) => target?.closest?.(".b-grid-row:not(.b-group-row)") ?? null,
  resolveTask: (plugin, rowEl) => {
    const grid = plugin.client;
    const record =
      (typeof grid.getRecordFromElement === "function"
        ? grid.getRecordFromElement(rowEl)
        : null) ?? null;
    return getOriginalRecord(record);
  },
});
